import { InputSize } from '@hb/shared'
import { CSSProperties } from 'react'
import { FormElement } from '../../forms/Input'
import { usePracticeProviderField, usePracticeProvidersField } from '../hooks/usePracticeProviders'

interface PracticeProviderSelectProps {
  practiceId: string | null
  name: string
  placeholder?: string
  size?: InputSize
  style?: CSSProperties
  inputStyle?: CSSProperties
  excludeIds?: string[]
}

export const PracticeProviderSelect = ({
  practiceId,
  name,
  placeholder,
  style,
  inputStyle,
  excludeIds,
  size,
}: PracticeProviderSelectProps) => {
  const field = usePracticeProviderField(practiceId, placeholder, excludeIds)
  return <FormElement field={field} name={name} style={style} inputStyle={inputStyle} size={size} />
}

export const PracticeProvidersSelect = ({
  practiceId,
  name,
  placeholder,
  style,
  inputStyle,
  excludeIds,
}: PracticeProviderSelectProps) => {
  const field = usePracticeProvidersField(practiceId, placeholder, excludeIds)
  return <FormElement field={field} name={name} style={style} inputStyle={inputStyle} />
}
